import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PreviousRouteService } from '../../services/previous-route.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionModel } from '../../../user/models/user-session.model';
import { PipesModule } from '../../pipes/pipes.module';

import { ButtonModule } from 'primeng/button';
import { LS_LAST_URL } from '../../../const';
import { PlatformNavigationService } from '../../../common/services/platform-navigation.service';
import { PlatformRouterLinks } from '../../../common/common.const';
import { Encryption } from '../../services/encryption.service';

@Component({
	selector: 'ui-page-not-found',
	styleUrls: ['./page-not-found.component.scss'],
	templateUrl: './page-not-found.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		PipesModule,
		ButtonModule,
	],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
	public mainUrl: string = PlatformNavigationService.getProtectedNavLink(PlatformRouterLinks.dashboard, PlatformRouterLinks.agency);
	public defaultUrls: string[] = [
		'/not_found',
		PlatformRouterLinks.login,
	];

	public isNotFoundPage: boolean = false;
	public timeoutId: number = null;
	private _destroy$: Subject<void> = new Subject<void>();
	private platformNavigationService = inject(PlatformNavigationService);

	constructor(
		private previousRouteService: PreviousRouteService,
		private route: ActivatedRoute,
	) {}

	ngOnDestroy(): void {
		clearTimeout(this.timeoutId);
		this._destroy$.next();
		this._destroy$.complete();
	}

	public ngOnInit(): void {
		this.route.url
			.pipe(takeUntil(this._destroy$))
			.subscribe((params: Params) => {
				this.isNotFoundPage = params[0]?.path === 'pageNotFound';
			});

		this.timeoutId = setTimeout(() => this.back(), 5000) as unknown as number;
	}

	public get hasPreviousUrl(): boolean {
		return (this.previousRouteService.previousUrl.length > 1 || (Encryption.getLsValue<string>(LS_LAST_URL) != null)) &&
			!this.defaultUrls.includes(this.previousRouteService.previousUrl);
	}

	public back(): void {
		let targetUrl: string = this.hasPreviousUrl
			? (this.previousRouteService.previousUrl || `/${Encryption.getLsValue<string>(LS_LAST_URL)}`)
			: (new UserSessionModel().isInternal() ? this.mainUrl : PlatformNavigationService.getProtectedNavLink(PlatformRouterLinks.advertisers, PlatformRouterLinks.agency));
		if (targetUrl && targetUrl.includes('//')) {
			targetUrl = targetUrl.replace('//', '/');
		}
		this.platformNavigationService.navigate(targetUrl);
	}
}
